"use client";

import React from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function GlossaryCallout() {
  return <section id="insuranceretirementglossarycallout" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="mx-auto max-w-[840px] px-4 md:px-6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }}>
          <Card className="rounded-xl border border-border bg-card shadow-xs transition-all duration-200 hover:border-accent hover:-translate-y-0.5">
            <CardContent className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 p-6 md:p-8">
              <div className="flex-1 space-y-2">
                <div className="flex items-center gap-2">
                  <Badge variant="secondary" className="gap-1.5 font-normal text-xs py-0.5 px-2.5">
                    <BookOpen className="size-3 text-muted-foreground" />
                    Reference Resource
                  </Badge>
                </div>
                <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-foreground font-default">
                  Insurance &amp; Retirement Glossary
                </h2>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  Plain-language definitions of common insurance, annuity, and retirement terms.
                </p>
              </div>

              <div className="shrink-0 pt-2 md:pt-0">
                <Link to="#" className="group inline-flex items-center gap-2 font-medium text-primary text-sm md:text-base hover:text-primary/80 transition-colors">
                  <span>View glossary</span>
                  <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>;
}